const iosCustomUrlSchemeBase = 'jpmycolorhotellovers://'
export const iosCustomUrlSchemes = {
  // WebViewを閉じる
  close: `${iosCustomUrlSchemeBase}keep`,
  // カートに遷移
  cart: `${iosCustomUrlSchemeBase}cart`,
  // サンクスページ（注文完了画面）に遷移
  orderComplete: `${iosCustomUrlSchemeBase}cart/thanks`,
  // マイページに遷移
  mypage: `${iosCustomUrlSchemeBase}mypage`,
  /**
   * 外部ブラウザで開く
   * 例: webview?path=/hlapp/external_account_association/line/start&openExternalBrowser=true
   *
   * アプリ側は以下のように動作する：
   * - アプリの認証状態をもとにo, hashを取得する
   * - pathがo, hashを解釈できるパス (/hlapp/direct/*) であればそのままo, hashを付けて開く
   * - pathがo, hashを解釈できないパスの場合、 /nc/auth/auto-login を経由して path を開く
   */
  createOpenExternalBrowser: (path: string) => `${iosCustomUrlSchemeBase}webview?path=${path}&openExternalBrowser=true`,
}
